import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage, zodSort } from 'routes/routeUtils';
import { z } from 'zod';

export const adminLabsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/labs',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
    sort: zodSort(['name']),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/admin/Labs/AdminLabsPage/AdminLabsPage').then((d) => d.Route));
